import { type FC } from 'react'
import { useAdvisorEngineContactSync } from '../IntegrationSpecificSettings/AdvisorEngine/hooks'
import { type CrmIntegrationSettings, type CrmSettingsProviderProps } from './types'

export const AdvisorEngineCrmSettingsProvider: FC<CrmSettingsProviderProps> = ({ children }) => {
  const contact = useAdvisorEngineContactSync()

  const settings: CrmIntegrationSettings = {
    contactSync: contact.autoSync ?? false,
    calendarSync: false,
    isSyncDisabled: contact.isSyncDisabled,
    isFetching: contact.isFetching,
    isSaving: contact.isSaving,
    save: async (patch) => {
      if (patch.contactSync !== undefined) {
        await contact.saveAutoSync(patch.contactSync)
      }
    },
  }

  return <>{children(settings)}</>
}
